import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../ApiEndpoint";

let initialState = {
    typedata: [],
    isLoading: false,
    isError: null,
};

//post api
export const addtype = createAsyncThunk("posttype", async (data, { rejectWithValue }) => {
    const { endpoint, payload } = data;
    try {
        const res = await axios.post(BASE_URL + endpoint, payload, { headers: { "Content-Type": "multipart/form-data" } });
        // console.log(res, "type post");

        return res.data.productType;
    } catch (error) {
        return rejectWithValue(error.response ? error.response.data : error.message);
    }
});

//Get api
export const gettype = createAsyncThunk("gettype", async ({ endpoint }, { rejectWithValue }) => {
    try {
        let res = await axios.get(BASE_URL + endpoint,);
        // console.log(res.data.productTypes, "res type get");
        return res.data.productTypes;
    } catch (Error) {
        return rejectWithValue(Error.response ? Error.response.data : Error.message);
    }
});

//delete api
export const deletetype = createAsyncThunk("deletetype", async (data, { rejectWithValue }) => {
    let { endpoint, uuid } = data;
    try {
        await axios.delete(BASE_URL + endpoint + uuid);
        // console.log(res, "delete res");

        return uuid;
    } catch (error) {
        return rejectWithValue(error.response ? error.response.data : error.message);
    }
});

//updata api 
export const updatetype = createAsyncThunk("updatetype", async (data, { rejectWithValue }) => {
    let { endpoint, uuid, payload } = data;
    try {
        const res = await axios.put(BASE_URL + endpoint + uuid, payload, { headers: { "Content-Type": "multipart/form-data" } });
        // console.log(res, "resresres type updata");

        return res.data.updatedProductType;
    } catch (error) {
        return rejectWithValue(error.response ? error.response.data : error.message);
    }
});



//slice
export const typedataSlice = createSlice({
    name: "typedata",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            //post method
            .addCase(addtype.pending, (state) => {
                state.isLoading = true;
                state.isError = false;
            })
            .addCase(addtype.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = action.payload; // Store the error message
            })
            .addCase(addtype.fulfilled, (state, action) => {
                state.isLoading = false;
                state.typedata.push(action.payload);
            })
            //get method
            .addCase(gettype.pending, (state) => {
                state.isLoading = true;
                state.isError = false;
            })
            .addCase(gettype.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = action.payload;
            })
            .addCase(gettype.fulfilled, (state, action) => {
                state.isLoading = false;
                state.typedata = action.payload;
            })
            //delete method
            .addCase(deletetype.pending, (state) => {
                state.isLoading = true;
                state.isError = null;
            })
            .addCase(deletetype.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = action.payload;
            })
            .addCase(deletetype.fulfilled, (state, action) => {
                state.isLoading = false;
                state.typedata = state.typedata.filter((item) => item.uuid !== action.payload);
            })
            //updata method
            .addCase(updatetype.pending, (state) => {
                state.isLoading = true;
                state.isError = null;
            })
            .addCase(updatetype.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = action.payload;
            })
            .addCase(updatetype.fulfilled, (state, action) => {
                state.isLoading = false;
                state.typedata = state.typedata.map((value) =>
                    value.uuid === action.payload.uuid ? action.payload : value
                );

            });

    },
});


export default typedataSlice.reducer;